export default __webpack_public_path__ + "static/media/logo_money.d872ff60.png";